import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { useState, createElement, Fragment, useContext, useRef, useCallback, createContext } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { EllipsisVerticalIcon } from '@tinacms/icons';
import { Dismissible } from 'react-dismissible';
import { createPortal } from 'react-dom';
import { FormBuilder, FieldsBuilder } from '@tinacms/form-builder';
import { Button } from '@tinacms/styles';
import { DragDropContext } from 'react-beautiful-dnd';
import { Modal, ModalPopup, ModalHeader, ModalBody, ModalActions } from '@tinacms/react-modals';
import { useCMS } from '@tinacms/react-core';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-0);\n  padding: 0 12px;\n  height: 40px;\n  font-weight: 500;\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: var(--tina-color-grey-1);\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, -28px, 0) scale3d(1, 1, 1);\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: var(--tina-padding-big);\n  right: var(--tina-padding-big);\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 100% 100%;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 64px;\n  width: 40px;\n  align-self: stretch;\n  background-color: transparent;\n  background-position: center;\n  background-size: auto 18px;\n  background-repeat: no-repeat;\n  border: 0;\n  margin: 0 -16px 0 8px;\n  outline: none;\n  cursor: pointer;\n  transition: opacity 85ms ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    fill: var(--tina-color-grey-8);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FormActionMenu = function FormActionMenu(_ref) {
  var actions = _ref.actions,
      form = _ref.form;

  var _useState = useState(false),
      actionMenuVisibility = _useState[0],
      setActionMenuVisibility = _useState[1];

  return createElement(Fragment, null, createElement(MoreActionsButton, {
    onClick: function onClick() {
      return setActionMenuVisibility(function (p) {
        return !p;
      });
    }
  }), createElement(ActionsOverlay, {
    open: actionMenuVisibility
  }, createElement(Dismissible, {
    click: true,
    escape: true,
    disabled: !actionMenuVisibility,
    onDismiss: function onDismiss() {
      setActionMenuVisibility(function (p) {
        return !p;
      });
    }
  }, actions.map(function (Action, i) {
    return (// TODO: `i` will suppress warnings but this indicates that maybe
      //        Actions should just be componets
      createElement(Action, {
        form: form,
        key: i
      })
    );
  }))));
};

var MoreActionsButton = /*#__PURE__*/styled(function (p) {
  return createElement("button", Object.assign({}, p), createElement(EllipsisVerticalIcon, null));
})( /*#__PURE__*/_templateObject());
var ActionsOverlay = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2(), function (props) {
  return props.open && css(_templateObject3());
});
var ActionButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject4());

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  scrollbar-width: none;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var FormPortalContext = /*#__PURE__*/createContext(function () {
  return null;
});

function useFormPortal() {
  return useContext(FormPortalContext);
}

var FormPortalProvider = /*#__PURE__*/styled(function (_ref) {
  var children = _ref.children,
      styleProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var wrapperRef = useRef(null);
  var FormPortal = useCallback(function (props) {
    if (!wrapperRef.current) return null;
    return createPortal(props.children, wrapperRef.current);
  }, [wrapperRef.current]);
  return createElement(FormPortalContext.Provider, {
    value: FormPortal
  }, createElement("div", Object.assign({
    ref: wrapperRef
  }, styleProps), children));
})( /*#__PURE__*/_templateObject$1());

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n    "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", " 2s linear infinite;\n  display: inline-block;\n  margin-right: 4px;\n  :nth-child(2) {\n    animation-delay: 0.3s;\n  }\n  :nth-child(3) {\n    animation-delay: 0.5s;\n  }\n  ", "\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% { transform: scale(0.1); }\n  50% { transform: scale(1); }\n  90% { transform: scale(0.1); }\n  100% { transform: scale(0.1); }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var LoadingDots = function LoadingDots(_ref) {
  var _ref$dotSize = _ref.dotSize,
      dotSize = _ref$dotSize === void 0 ? 8 : _ref$dotSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color;
  return createElement("div", null, createElement(SingleDot, {
    dotSize: dotSize,
    color: color
  }), createElement(SingleDot, {
    dotSize: dotSize,
    color: color
  }), createElement(SingleDot, {
    dotSize: dotSize,
    color: color
  }));
};

var scaleUpAndDown = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$2());
var SingleDot = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject2$1(), scaleUpAndDown, function (_ref2) {
  var color = _ref2.color,
      dotSize = _ref2.dotSize;
  return css(_templateObject3$1(), color, dotSize, dotSize, dotSize);
});

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 0 0 96px;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var ResetForm = function ResetForm(_ref) {
  var pristine = _ref.pristine,
      reset = _ref.reset,
      children = _ref.children;

  var _React$useState = useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];

  return createElement(Fragment, null, createElement(ResetButton, {
    onClick: function onClick() {
      setOpen(function (p) {
        return !p;
      });
    },
    disabled: pristine
  }, children), open && createElement(ResetModal, {
    reset: reset,
    close: function close() {
      return setOpen(false);
    }
  }));
};

var ResetModal = function ResetModal(_ref2) {
  var close = _ref2.close,
      reset = _ref2.reset;
  return createElement(Modal, null, createElement(ModalPopup, null, createElement(ModalHeader, {
    close: close
  }, "Reset"), createElement(ModalBody, {
    padded: true
  }, createElement("p", null, "Are you sure you want to reset all changes?")), createElement(ModalActions, null, createElement(Button, {
    onClick: close
  }, "Cancel"), createElement(Button, {
    margin: true,
    primary: true,
    onClick: function onClick() {
      try {
        return Promise.resolve(reset()).then(function () {
          close();
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, "Reset"))));
};

var ResetButton = /*#__PURE__*/styled(Button)( /*#__PURE__*/_templateObject$3());

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1.5 0 auto;\n  padding: 12px 24px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  background-color: white;\n  border-top: 1px solid var(--tina-color-grey-2);\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  scrollbar-width: none;\n  width: 100%;\n  overflow: hidden;\n  border-top: 1px solid var(--tina-color-grey-2);\n  background-color: #f6f6f9;\n\n  ", " {\n    height: 100%;\n    scrollbar-width: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin: 0 auto;\n  max-width: 500px;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  box-shadow: var(--tina-shadow-small);\n  font-weight: 500;\n  cursor: pointer;\n  font-size: var(--tina-font-size-0);\n  transition: all var(--tina-timing-short) ease-out;\n  background-color: white;\n  color: var(--tina-color-grey-8);\n  padding: var(--tina-padding-small) var(--tina-padding-big)\n    var(--tina-padding-small) 56px;\n  position: relative;\n  text-decoration: none;\n  display: inline-block;\n  ", " {\n    font-size: 24px;\n    position: absolute;\n    left: var(--tina-padding-big);\n    top: 50%;\n    transform-origin: 50% 50%;\n    transform: translate3d(0, -50%, 0);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n  &:hover {\n    color: var(--tina-color-primary);\n    ", " {\n      transform: translate3d(0, -50%, 0);\n    }\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: var(--tina-padding-big) var(--tina-padding-big) 64px\n    var(--tina-padding-big);\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  animation-name: ", ";\n  animation-delay: 300ms;\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n  > *:first-child {\n    margin: 0 0 var(--tina-padding-big) 0;\n  }\n  > ", " {\n    display: block;\n  }\n  h3 {\n    font-size: var(--tina-font-size-5);\n    font-weight: normal;\n    color: inherit;\n    display: block;\n    margin: 0 0 var(--tina-padding-big) 0;\n    ", " {\n      font-size: 1em;\n    }\n  }\n  p {\n    display: block;\n    margin: 0 0 var(--tina-padding-big) 0;\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 40px;\n  line-height: 1;\n  display: inline-block;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

function FormView(_ref) {
  var activeForm = _ref.activeForm;
  var cms = useCMS(); // @ts-ignore

  var buttons = cms.sidebar.buttons;
  var moveArrayItem = useCallback(function (result) {
    if (!result.destination || !activeForm) return;
    var name = result.type;
    activeForm.mutators.move(name, result.source.index, result.destination.index);
  }, [activeForm]);
  return createElement(FormBuilder, {
    form: activeForm
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
        pristine = _ref2.pristine,
        form = _ref2.form,
        submitting = _ref2.submitting;
    return createElement(DragDropContext, {
      onDragEnd: moveArrayItem
    }, createElement(FormBody, null, createElement(FormPortalProvider, null, createElement(Wrapper, null, activeForm && (activeForm.fields.length ? createElement(FieldsBuilder, {
      form: activeForm,
      fields: activeForm.fields
    }) : createElement(NoFieldsPlaceholder, null))))), createElement(FormFooter, null, createElement(Wrapper, null, activeForm.reset && createElement(ResetForm, {
      pristine: pristine,
      reset: function reset() {
        try {
          form.reset();
          return Promise.resolve(activeForm.reset()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }, buttons.reset), createElement(Button, {
      onClick: function onClick() {
        return handleSubmit();
      },
      disabled: pristine,
      busy: submitting,
      primary: true,
      grow: true,
      margin: true
    }, submitting && createElement(LoadingDots, null), !submitting && buttons.save), activeForm.actions.length > 0 && createElement(FormActionMenu, {
      actions: activeForm.actions,
      form: activeForm
    }))));
  });
}

var Emoji = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$4());
var EmptyStateAnimation = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject2$2());
var EmptyState = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$2(), EmptyStateAnimation, Emoji, Emoji);
var LinkButton = /*#__PURE__*/styled.a( /*#__PURE__*/_templateObject4$1(), Emoji, Emoji);

var NoFieldsPlaceholder = function NoFieldsPlaceholder() {
  return createElement(EmptyState, null, createElement(Emoji, null, "\uD83E\uDD14"), createElement("h3", null, "Hey, you don't have any fields added to this form."), createElement("p", null, createElement(LinkButton, {
    href: "https://tinacms.org/docs/gatsby/markdown/#creating-remark-forms",
    target: "_blank"
  }, createElement(Emoji, null, "\uD83D\uDCD6"), " Field Setup Guide")));
};

var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5());
var FormBody = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6(), Wrapper);
var FormFooter = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7(), Wrapper);
var SaveButton = /*#__PURE__*/styled(Button)( /*#__PURE__*/_templateObject8());
export { ActionButton, FormActionMenu, FormBody, FormPortalProvider, FormView, LoadingDots, ResetForm, SaveButton, Wrapper, useFormPortal };